/**
 * report page from 'data-set-list-page'
 * datasetId is required
 */
import '@operato/data-grist'
import '@things-factory/form-ui'

import { css, html } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'
import { CommonButtonStyles, ScrollbarStyles } from '@operato/styles'
import { encodeUrlParams } from '@operato/utils'

@customElement('data-report-embed-page')
export class DataReportEmbedPage extends localize(i18next)(PageView) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        padding: 0;
      }

      #container {
        flex: 1;
        padding: 0;
        margin: 0;
        border: 0;
      }
    `
  ]

  @query('iframe') iframe!: HTMLIFrameElement

  get context() {
    const filters = [
      {
        name: 'workDateRange',
        type: 'date',
        label: 'date',
        operator: 'between'
      }
    ]
    var actions = [
      {
        title: i18next.t('button.print'),
        action: () => {
          this.iframe.contentWindow?.print()
        },
        ...CommonButtonStyles.print
      }
    ]
    return {
      title: 'data-report-embed',
      actions,
      filters
    }
  }
  render() {
    return html`
      <ox-filters-form-base
        .filters=${this.context.filters}
        @filters-change=${e => {
          console.log('filters changed', e.detail)
          this.reportTemplate(e.detail.filters)
        }}
        ?url-params-sensitive=${this.active}
      ></ox-filters-form-base>
      <iframe frameborder="0" style="border:0"></iframe>
    `
  }

  async pageUpdated(changes, lifecycle) {
    if (this.active) {
      this.updateContext()
    }
  }

  async reportTemplate(filters) {
    // convert filters array to object
    const params = filters.reduce((acc, curr) => ((acc[curr.name] = curr.value), acc), {})
    Object.assign(params, this.lifecycle.params)

    const { id, workDateRange, workShift, reportType, reportView } = params

    /** ignoring date conditions  */
    if (!workDateRange[0] || !workDateRange[1] || workDateRange[0] > workDateRange[1]) {
      return
    }

    /** urlencoded params including test values */
    const urlParams = {
      table: 'samples',
      dataSetId: id,
      startDate: workDateRange[0],
      endDate: workDateRange[1],
      workShift,
      reportView
    }

    const encodedUrlParams = encodeUrlParams(urlParams)

    this.iframe.src = `/data-report/${reportType}/?${encodedUrlParams}`
  }
}
